export default function StringField({ field, value, onChange }) {
	// console.log(`TCL -> StringField.jsx:2 -> StringField -> field:`, field)
	return (
		<div className="col-span-full">
			<label htmlFor={field.name} className="block text-sm/6 font-medium text-gray-900">
				{field.label || field.name}
				{field.required && <span className="text-red-500 ml-1">*</span>}
			</label>
			<div className="mt-2">
				<input
					id={field.name}
					name={field.name}
					type="text"
					value={value}
					onChange={e => onChange(field.name, e.target.value)}
					required={field.required}
					className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
				/>
			</div>
		</div>
	)
}
